import callApi from 'client/util/apiCaller';

// Organization API actions (thunks). These return API responses and can be
// composed by components; we don't persist organization state in Redux yet.

export function fetchOrganization(token, organizationId) {
  return dispatch => {
    return callApi(dispatch, `organizations/${organizationId}`, token, 'GET');
  };
}

export function updateOrganization(token, organizationId, data) {
  return dispatch => {
    return callApi(dispatch, `organizations/${organizationId}`, token, 'PUT', data);
  };
}

export function startDomainVerification(token, organizationId, domain) {
  return dispatch => {
    return callApi(
      dispatch,
      `organizations/${organizationId}/domain/verify/start`,
      token,
      'POST',
      { domain }
    );
  };
}

export function confirmDomainVerification(token, organizationId, domain) {
  return dispatch => {
    return callApi(
      dispatch,
      `organizations/${organizationId}/domain/verify/confirm`,
      token,
      'POST',
      { domain }
    );
  };
}

export function removeDomainVerification(token, organizationId, domain) {
  return dispatch => {
    return callApi(
      dispatch,
      `organizations/${organizationId}/domain/${encodeURIComponent(domain)}`,
      token,
      'DELETE'
    );
  };
}


